import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledLegend = styled(Flex)`
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
